<script setup lang="ts"></script>

<template>
  <fieldset class="flex max-w-max items-center justify-start gap-x-3 pl-2">
    <FormKit type="group" name="priority">
      <FormKit type="checkbox" :value="true" name="low">
        <template #label
          ><i class="fa-solid fa-fire-flame-simple pr-1 text-lg text-yellow-500"></i
          ><span class="font-semibold">Low</span></template
        >
      </FormKit>
      <FormKit type="checkbox" name="medium" :value="true">
        <template #label
          ><i class="fa-solid fa-fire-flame-simple pr-1 text-lg text-orange-400"></i
          ><span class="font-semibold">Medium</span></template
        >
      </FormKit>
      <FormKit type="checkbox" name="high" :value="true">
        <template #label
          ><i class="fa-solid fa-fire-flame-simple pr-1 text-lg text-red-500"></i
          ><span class="font-semibold">High</span></template
        >
      </FormKit>
    </FormKit>
    <FormKit type="toggle" name="my_tickets" label="View My Tickets Only" :classes="{ wrapper: '!mb-0' }" />
  </fieldset>
</template>
